
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCautionBadgeOutline as ObiCautionBadgeOutlineElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-caution-badge-outline.js';
 
 
 

 
 export const ObiCautionBadgeOutline = createComponent({
   react: React,
   tagName: 'obi-caution-badge-outline',
   elementClass: ObiCautionBadgeOutlineElement,
   events: {
     
   }
  });
 
 